export const contexts = {
  login: 'login',
  authentication: 'authentication',
  posts: 'posts',
  addPost: 'addPost',
  doctors: 'doctors',
  companyActivation: 'companyActivation',
  companies: 'companies',
  addCompany: 'addCompany',
  profile: 'profile',
  rssFeed: 'rssFeed',
  addRssFeed: 'addRssFeed',
  closedCircles: 'closedCircles',
  notFound: 'notFound',
};

export const contextToPageNameMap = {
  login: 'Login',
  authentication: 'authentication',
  posts: 'Posts',
  addPost: 'Add Post',
  doctors: 'Doctor Activation',
  companyActivation: 'Company Activation',
  companies: 'Companies',
  addCompany: 'Add Company',
  profile: 'Profile',
  rssFeed: 'Rss Feed',
  addRssFeed: 'Add Rss Feed',
  closedCircles: 'Circles',
  notFound: 'Not Found',
};
